export const circularCharts = ['pie', 'doughnut', 'polar' ]